import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useCartIntermediateContext } from '../../../context/CartIntermediateContext'

export const CartIntermediateProductInfoRedpoints: FC = () => {
  const { redPoints } = useCartIntermediateContext()

  return (
    redPoints > 0 && (
      <div className="text-dark-redpoints">
        {'+ '}
        <FormattedMessage
          id="general.label.product.redPoints"
          values={{ redPoints }}
        />
      </div>
    )
  )
}
